import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Checkout page - Redirects to Paystack hosted payment page
 *
 * This page now simply redirects to the appropriate Paystack hosted payment page.
 * The Paystack hosted page collects all necessary information (email, name, payment)
 * eliminating the need for our own checkout form.
 *
 * Flow:
 * 1. User clicks "Buy Now" on templates page
 * 2. Redirected to this route (/checkout/tripwire)
 * 3. This component redirects to Paystack hosted page
 * 4. User completes payment on Paystack
 * 5. Paystack redirects back to /thank-you
 * 6. Webhook creates order + entitlement
 * 7. User receives magic link email
 */
export default function Checkout() {
  const { productId } = useParams<{ productId: string }>();

  useEffect(() => {
    // Redirect to appropriate Paystack hosted payment page based on productId
    if (productId === 'tripwire') {
      window.location.href = 'https://paystack.shop/pay/dealvelocity-tripwire';
    } else {
      // For other products, redirect to templates page
      window.location.href = '/templates';
    }
  }, [productId]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-xl text-secondary">Redirecting to payment page...</div>
    </div>
  );
}
